import React, { createContext, useContext } from "react";

const CookieConsentContext = createContext();

export const useCookieConsent = () => {
	const context = useContext(CookieConsentContext);
	if (!context) {
		throw new Error(
			"useCookieConsent must be used within a CookieConsentProvider"
		);
	}
	return context;
};

export const CookieConsentProvider = ({ children, onShowCookieConsent }) => {
	return (
		<CookieConsentContext.Provider value={{ onShowCookieConsent }}>
			{children}
		</CookieConsentContext.Provider>
	);
};
